//
import { mapActions, mapState } from 'vuex'
import {
    ModelAutocomplete,
    ModelDataTable,
} from '@/components/reusable_components/next'

//
import ProductModel from '@/models/Warehouse/WhProductToList'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'product-list',
    components: {
        'model-autocomplete': ModelAutocomplete,
        'model-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        autocompleteProps() {
            return {
                model: WarehouseModel,
                paramFilter: {
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                },
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                service: ProductModel,
                filters,
                headers,
                paramFilter: {
                    of_warehouse: this.warehouse,
                    type: 'item',
                },
                rowsPerPage: 10,
            }
        },

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            selected: null,
            warehouse: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'product-update',
                params: { id: event.item.id },
            })
        },
    },
    beforeMount() {
        this.setTitleTopBar('Productos por bodega')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PRODUCT_BY_WAREHOUSE'))
                ctx.$router.push('/')
        })
    },
}
